module.exports = __webpack_public_path__ + "static/media/banner1.bc35086b.jpg";